import { z } from 'zod';

export const apiErrorResponse = z.object({
  error: z.string(),
  message: z.string().optional(),
  details: z.unknown().optional(),
});
export type ApiErrorResponse = z.infer<typeof apiErrorResponse>;

// Wire-level error codes used by the API.
export const ApiErrorCode = {
  Unauthorized: 'Unauthorized',
  Forbidden: 'Forbidden',
  BadRequest: 'Bad Request',
  NotFound: 'Not Found',
  ServiceUnavailable: 'Service Unavailable',
  GatewayTimeout: 'Gateway Timeout',
  UpstreamError: 'Upstream Error',
  Internal: 'Internal Server Error',
} as const;
export type ApiErrorCode = (typeof ApiErrorCode)[keyof typeof ApiErrorCode];
